import { useEffect, useState } from "react";
import _ from "lodash";

const useSort = (initialData) => {
  const [sortData, setSortData] = useState(initialData);
  const [sortOrderList, setSortOrderList] = useState({});

  useEffect(() => {
    const sortedData = _.orderBy(
      [...initialData],
      Object.keys(sortOrderList),
      Object.values(sortOrderList)
    );
    setSortData(sortedData);
  }, [initialData, sortOrderList]);

  const handleSortColumn = (columnSort) => {
    setSortOrderList((prevData) => {
      let newSortOrderList = { ...prevData };
      if (columnSort in newSortOrderList) {
        if (newSortOrderList[columnSort] === "asc") {
          newSortOrderList[columnSort] = "desc";
        } else {
          delete newSortOrderList[columnSort];
        }
      } else {
        newSortOrderList[columnSort] = "asc";
      }
      return newSortOrderList;
    });
  };

  return { sortData, sortOrderList, handleSortColumn };
};

export const useSortTable = (tableData, noSortData, setTableData) => {
  const [sortOrderList, setSortOrderList] = useState({});
  useEffect(() => {
    const sortData = () => {
      const columnsToSort = Object.keys(sortOrderList);
      const orders = Object.values(sortOrderList);
      return _.orderBy([...tableData], columnsToSort, orders);
    };
    if (_.isEmpty(sortOrderList)) {
      setTableData(noSortData ?? []);
    } else {
      const newSortData = sortData();
      setTableData(newSortData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortOrderList]);

  // Function handle Sort
  const handleSortColumn = (columnSort) => {
    const newSort = { ...sortOrderList };
    if (!newSort[columnSort]) {
      newSort[columnSort] = "asc";
    } else if (sortOrderList[columnSort] === "asc") {
      newSort[columnSort] = "desc";
    } else if (sortOrderList[columnSort] === "desc") {
      delete newSort[columnSort];
    }
    setSortOrderList(newSort);
  };

  return { sortOrderList, handleSortColumn };
};

export default useSort;
